import { useState, useEffect, useCallback } from "react";

import ReportsService from "@/services/reportsService";

const PERIOD_MAP = {
  today: "today",
  yesterday: "yesterday",
  thisWeek: "this_week",
  thisMonth: "this_month",
  lastMonth: "last_month",
};

const formatDate = (d) =>
  d instanceof Date ? d.toISOString().split("T")[0] : d;

export default function useItemWiseSales(initialFilters = {}) {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({
    totalItemsSold: 0,
    totalRevenue: 0,
    uniqueItemsSold: 0,
    avgItemPrice: 0,
  });
  const [branchSummary, setBranchSummary] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    period: "thisMonth",
    startDate: undefined,
    endDate: undefined,
    offset: 0,
    limit: 25,
    sortColumn: "revenue",
    sortDirection: "DESC",
  });

useEffect(() => {
  if (initialFilters && Object.keys(initialFilters).length > 0) {
    setFilters((prev) => ({ ...prev, ...initialFilters }));
  }

}, []);


  const fetchItemWiseSales = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        offset: filters.offset,
        limit: filters.limit,
        sortColumn: filters.sortColumn,
        sortDirection: filters.sortDirection,
      };

      if (filters.branchId) params.branchId = filters.branchId;

      if (filters.startDate && filters.endDate) {
        params.startDate = formatDate(filters.startDate);
        params.endDate = formatDate(filters.endDate);
      } else if (filters.period) {
        params.period = PERIOD_MAP[filters.period] ?? filters.period;
      }

      const res = await ReportsService.getItemWiseSales(params);
      const apiData = res?.data?.data ?? res?.data ?? res;

      const rows =
        apiData?.table?.content?.map((row, index) => ({
          id: `${row.itemCode}-${index}`,

          itemCode: row.itemCode,
          itemName: row.itemName,
          categoryName: row.category,
          quantitySold: row.qtySold,
          grossRevenue: row.revenue,
          avgSellingPrice: row.avgPrice,
          // revenuePercentage: row.contribution,
          contribution: row.contribution, 

          isVeg: row.isVeg,
          rank: index + 1,
          branchId: row.branchId,
        })) ?? [];

      setData(rows);
      setSummary({
        totalItemsSold:
          apiData?.summary?.totalItemsSold ??
          apiData?.summary?.total_items_sold ??
          0,

        totalRevenue:
          apiData?.summary?.totalRevenue ??
          apiData?.summary?.total_revenue ??
          0,

        uniqueItemsSold:
          apiData?.summary?.uniqueItems ??
          apiData?.summary?.unique_items ??
          apiData?.summary?.uniqueItemsSold ??
          0,

        avgItemPrice:
          apiData?.summary?.avgItemPrice ??
          apiData?.summary?.avg_item_price ??
          0,
      });

      setBranchSummary(apiData?.branchSummary ?? []);
      setTotalItems(apiData?.table?.totalElements ?? 0);
    } catch (err) {
      console.error(" useItemWiseSales ERROR:", err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchItemWiseSales();
  }, [fetchItemWiseSales]);

  return {
    data,
    summary,
    branchSummary,
    totalItems,
    loading,
    setFilters,
    refresh: fetchItemWiseSales,
  };
}
